import React, { useEffect, useContext } from 'react';
import { APIList } from './api/APIList';
import { Webservice } from '../services/Webservice';
import { sorting, Store, StoreState } from './Store';
import { IconSpinner } from '../icons/icon';
import { Filter } from './Filter';
import { ErrorResponse } from '../services/model';
import { Footer } from './Footer';
import { Header } from './Header';
import { ErrorElement } from './ErrorElement';

export const APIs: React.FC = () => {
    const { isInternal, apis, error, filter, sort } = useContext(Store);

    useEffect(() => {
        Webservice.getAPIs()
            .then((allAPIsResponse) => {
                if (allAPIsResponse)
                    StoreState.set({ isInternal: allAPIsResponse.isInternal, apis: allAPIsResponse.apis });
            })
            .catch((error: ErrorResponse) => {
                StoreState.set({ error: error });
            });
    }, []);

    if (error) {
        return <ErrorElement error={error} />;
    }

    if (!apis) {
        return (
            <main className="loading main-container">
                <IconSpinner className="big-spinner" />
            </main>
        );
    }

    return (
        <React.Fragment>
            <Header logoHref="/" isInternal={isInternal} />
            <main className="container main-container d-flex flex-column min-vh-100">
                <div className="flex-fill container">
                    <Filter />
                    <APIList
                        isInternal={isInternal ? isInternal : false}
                        apis={apis
                            .filter(
                                (api) =>
                                    !filter ||
                                    api.metadata.identifier.includes(filter.toLowerCase()) ||
                                    api.metadata.stage.includes(filter) ||
                                    api.metadata.apiVersion.includes(filter) ||
                                    api.metadata.title.toLowerCase().includes(filter.toLowerCase())
                            )
                            .sort((a, b) =>
                                sort === sorting.asc
                                    ? a.metadata.title.localeCompare(b.metadata.title)
                                    : b.metadata.title.localeCompare(a.metadata.title)
                            )}
                        currentSort={sort ? sort : sorting.asc}
                    />
                </div>
                <Footer />
            </main>
        </React.Fragment>
    );
};
